import { Detail } from './Detail';

export class RisorsaZund extends Detail {
    risorsaId: number;
    cartellaCoda: string;
    cartellaCompleti: string;
    cartellaHotFolder: string;
}
